import { Maybe } from "types";

import { UUID_REGEX } from "./constants";

/**
 * Get filename from URL
 * @param {string} url - URL with file name
 */
export const getFileName = (url: Maybe<string>) => url?.match(/\/([^/]+$)/)?.[1] ?? "";

/**
 * Get the Number UUID from the URL
 */

export const getNumberUuidFromURL = (url: string): string | null => {
  const match = url.match(UUID_REGEX);
  if (!match) return null;

  const uuid = match[0];

  // Paths where UUIDs should be ignored, e.g /org/xxx
  for (const path of ["/org/", "/playbooks/", "/c/"]) {
    if (url.toLowerCase().includes(`${path.toLowerCase()}${uuid.toLowerCase()}`)) {
      return null;
    }
  }

  return uuid;
};
/**
 * Get the chat UUID from the URL /c/:chatUUid
 */

export const getChatPermalinkUuidFromURL = (url: string): string | null => {
  const CHAT_UUID_REGEX = new RegExp(`/c/(${UUID_REGEX.source})`, "i");

  const match = url.match(CHAT_UUID_REGEX);
  if (!match) return null;

  const uuid = match[1];
  return uuid;
};
